import { InfoTooltip } from '@oaknorth/component-core-v2';
import { T } from '@oaknorth/util-intl';

export const BorrowerIRRTooltip = () => <InfoTooltip content={T`vr.borrower.irr.tooltip`} />;
